(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire982d"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire982d"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8B93W", function(module, exports) {

var $dpo9Q = parcelRequire("dpo9Q");

var $kx6Ww = parcelRequire("kx6Ww");

var $4Y76G = parcelRequire("4Y76G");

var $frcpX = parcelRequire("frcpX");
requestIdleCallback(function() {
    (0, $dpo9Q.setupCalJs)();
    (0, $kx6Ww.snowAnimationStart)((0, $4Y76G.snowfallJsPluginParams));
    /* 
    The language preference check and text translation rendering happens in a different process and will have been triggered before the snow animation switches are appended to the DOM. Thus, re-render the span text element text once the snowAnimationSwitch are present in the DOM.
  */ var switchesTextElems = document.querySelectorAll(".snow-animation-switch span");
    if (switchesTextElems.length > 0) (0, $frcpX.reRenderTextElementText)(switchesTextElems);
});

});
parcelRegister("dpo9Q", function(module, exports) {

$parcel$export(module.exports, "setupCalJs", function () { return $9c3059656cacfd94$export$8d945a966a7346e9; });
/*
###################  
Cal.com plugin code 
###################  
*/ function $9c3059656cacfd94$export$9340b22841e69e75(C, A, L) {
    var p = function p(a, ar) {
        a.q.push(ar);
    };
    var d = C.document;
    C.Cal = C.Cal || function() {
        var cal = C.Cal;
        var ar = arguments;
        if (!cal.loaded) {
            cal.ns = {};
            cal.q = cal.q || [];
            d.head.appendChild(d.createElement("script")).src = A;
            cal.loaded = true;
        }
        if (ar[0] === L) {
            var api = function api1() {
                p(api, arguments);
            };
            var namespace = ar[1];
            api.q = api.q || [];
            typeof namespace === "string" ? (cal.ns[namespace] = api) && p(api, ar) : p(cal, ar);
            return;
        }
        p(cal, ar);
    };
}
function $9c3059656cacfd94$export$8d945a966a7346e9() {
    // Important: Make sure to add `data-cal-link="liondigits/20min"` attribute to the element you want to open Cal on click
    try {
        $9c3059656cacfd94$export$9340b22841e69e75(window, "https://app.cal.com/embed/embed.js", "init");
        Cal("init", {
            origin: "https://app.cal.com"
        });
        Cal("ui", {
            theme: "dark",
            styles: {
                branding: {
                    brandColor: "#003F8C"
                }
            },
            hideEventTypeDetails: false
        });
    } catch (e) {
        console.log("Calendar unable to loaded");
    }
}

});

parcelRegister("kx6Ww", function(module, exports) {

$parcel$export(module.exports, "snowfallState", function () { return $ef2c466908e09b36$export$5596bf805767acab; });
$parcel$export(module.exports, "params", function () { return $ef2c466908e09b36$export$281ad3752a540efe; });
$parcel$export(module.exports, "snowAnimationStart", function () { return $ef2c466908e09b36$export$e539e1c934021278; });
$parcel$export(module.exports, "initSnowfall", function () { return $ef2c466908e09b36$export$341e4017f7fc0f7a; });

var $9it1A = parcelRequire("9it1A");

var $b2X0T = parcelRequire("b2X0T");

var $108uK = parcelRequire("108uK");

var $29t6j = parcelRequire("29t6j");

var $liPuM = parcelRequire("liPuM");

var $idtF5 = parcelRequire("idtF5");
var $ef2c466908e09b36$export$5596bf805767acab = {
    snowfallInstance: undefined,
    isAnimationRunning: false
};
var $ef2c466908e09b36$export$281ad3752a540efe = {};
function $ef2c466908e09b36$export$e539e1c934021278() {
    var configParams = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (configParams.logLevel === "info") $ef2c466908e09b36$export$281ad3752a540efe.logLevel = "info";
    (0, $idtF5.logInfo)("Validating snowfall-js-plugin parameters...");
    $ef2c466908e09b36$export$281ad3752a540efe = (0, $29t6j.setParams)(configParams);
    var canRun = (0, $b2X0T.canRunAnimation)($ef2c466908e09b36$export$281ad3752a540efe);
    if (canRun) {
        var autoStart = (0, $liPuM.getAutoStart)($ef2c466908e09b36$export$281ad3752a540efe);
        (0, $108uK.switchesAppendToDOM)($ef2c466908e09b36$export$281ad3752a540efe);
        (0, $108uK.switchesSetupEventHandlers)($ef2c466908e09b36$export$281ad3752a540efe);
        if (autoStart) {
            $ef2c466908e09b36$export$5596bf805767acab.snowfallInstance = $ef2c466908e09b36$export$341e4017f7fc0f7a($ef2c466908e09b36$export$281ad3752a540efe.snowfall);
            $ef2c466908e09b36$export$5596bf805767acab.isAnimationRunning = true;
            (0, $108uK.switchesToggleOn)();
            (0, $idtF5.logInfo)("Done loading and starting animation.");
        }
    } else return;
}
function $ef2c466908e09b36$export$341e4017f7fc0f7a(params) {
    try {
        var snowfall = new (0, $9it1A.Snowfall)(params);
        return snowfall;
    } catch (err) {
        (0, $idtF5.logError)("Error initializing Snowfall instance");
        throw err;
    }
}

});
parcelRegister("9it1A", function(module, exports) {

$parcel$export(module.exports, "Snowfall", function () { return $6c4c4f2fa51b5901$export$863fc42fa99cded6; });
/*!
 * Snowfall.js - A JavaScript library for creating and animating snowflakes on a web page
 * https://github.com/Andrey-1988-dev/snowfall.js
 *
 * Author: Andrey Yurkevich (https://github.com/Andrey-1988-dev)
 * Contact: yurkevich.a.n.1988@gmail.com
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License
 * along with this program.  If not, see <https://www.gnu.org/licenses/>.
 *
 * Version: 1.1.0
 * Date: 2021-11-27T00:00Z
 *
 * Date Modified: 2024-01-31
 * The current code below is a fork of the original with minor additions,
 * optimization and extensions. The same license applies.
 *
 * Contributor: Joris Raymaekers (https://liondigits.com/)
 * Contact: joris@liondigits.com
 * Github: https://github.com/jorishr/snowfall-js-plugin
 */ 
var $7uGB1 = parcelRequire("7uGB1");

var $kmCzq = parcelRequire("kmCzq");

var $bHebQ = parcelRequire("bHebQ");

var $kx6Ww = parcelRequire("kx6Ww");
var $6c4c4f2fa51b5901$export$3966b366d9a665fb = /*#__PURE__*/ function() {
    "use strict";
    function Snowflake(canvas, h, s, c, t) {
        var _this = this;
        (0, $7uGB1._)(this, Snowflake);
        /**
   * Calculates and returns the new position of the snowflake relative to the edge of the canvas.
   *
   * @param {number} oldPosition - The old position of the snowflake.
   * @param {number} oldCanvasSize - The old size of the canvas.
   * @param {number} newCanvasSize - The new size of the canvas.
   * @returns {number} - The new position of the snowflake.
   */ (0, $bHebQ._)(this, "calculateNewPosition", function(oldPosition, oldCanvasSize, newCanvasSize) {
            var percentage = oldPosition / (oldCanvasSize / 100);
            return newCanvasSize / 100 * percentage;
        });
        /**
   * Updates the position of the snowflake after canvas resize.
   *
   * @param {number} oldCanvasWidth - The old canvas width.
   * @param {number} oldCanvasHeight - The old canvas height.
   * @param {number} newCanvasWidth - The new canvas width.
   * @param {number} newCanvasHeight - The new canvas height.
   */ (0, $bHebQ._)(this, "updateAfterCanvasResize", function(oldCanvasWidth, oldCanvasHeight, newCanvasWidth, newCanvasHeight) {
            if (oldCanvasWidth !== newCanvasWidth) _this.x = _this.calculateNewPosition(_this.x, oldCanvasWidth, newCanvasWidth);
            if (oldCanvasHeight !== newCanvasHeight) _this.y = _this.calculateNewPosition(_this.y, oldCanvasHeight, newCanvasHeight);
        });
        /**
   * Draws the snowflake on the canvas if it is within the visible area.
   *
   * @param {CanvasRenderingContext2D} ctx - The canvas rendering context.
   */ (0, $bHebQ._)(this, "draw", function(ctx) {
            // Check if the snowflake is within the visible area
            if (_this.x + _this.h >= window.scrollX && _this.x - _this.h <= window.scrollX + window.innerWidth && _this.y + _this.h >= window.scrollY && _this.y - _this.h <= window.scrollY + window.innerHeight) {
                ctx.fillStyle = _this.c; // set the color
                ctx.font = _this.h + "px Arial, sans-serif"; // set the font and text size
                ctx.fillText(_this.t, _this.x, _this.y); // draw the text with the snowflake symbol
            }
        });
        /**
   * Checks if the snowflake is inside the visible window.
   *
   * @param {number} scrollX - The horizontal scroll position.
   * @param {number} scrollY - The vertical scroll position.
   * @param {number} windowWidth - The window width.
   * @param {number} windowHeight - The window height.
   * @returns {boolean} - True if visible, false otherwise.
   */ (0, $bHebQ._)(this, "isVisible", function(scrollX, scrollY, windowWidth, windowHeight) {
            return _this.x + _this.h >= scrollX && _this.x - _this.h <= scrollX + windowWidth && _this.y + _this.h >= scrollY && _this.y - _this.h <= scrollY + windowHeight;
        });
        /**
   * Updates the position of the snowflake.
   *
   * @param {HTMLCanvasElement} canvas - The canvas element.
   */ (0, $bHebQ._)(this, "update", function(canvas) {
            // increase the y coordinate by the speed
            _this.y += _this.s;
            if (_this.s > 0) // if the snowflake goes beyond the bottom edge of the canvas, move it to the top
            {
                if (_this.y > canvas.height) {
                    _this.y = -_this.h;
                    _this.x = Math.random() * canvas.width;
                }
            } else if (_this.y < 0) {
                _this.y = canvas.height + _this.h;
                _this.x = Math.random() * canvas.width;
            }
        });
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.h = h;
        this.s = s;
        this.c = c;
        this.t = t;
    }
    (0, $kmCzq._)(Snowflake, null, [
        {
            key: "batchDraw",
            value: /**
   * Batch draws snowflakes for better performance.
   *
   * @param {CanvasRenderingContext2D} ctx - The canvas rendering context.
   * @param {Snowflake[]} snowflakes - Array of snowflake instances.
   * @param {number} scrollX - The horizontal scroll position.
   * @param {number} scrollY - The vertical scroll position.
   * @param {number} windowWidth - The window width.
   * @param {number} windowHeight - The window height.
   */ function batchDraw(ctx, snowflakes, scrollX, scrollY, windowWidth, windowHeight) {
                // FillStyle is the same for all snowflakes
                ctx.fillStyle = snowflakes[0].c;
                ctx.beginPath();
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = snowflakes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var snowflake = _step.value;
                        if (snowflake.isVisible(scrollX, scrollY, windowWidth, windowHeight)) {
                            ctx.font = snowflake.h + "px Arial, sans-serif";
                            ctx.fillText(snowflake.t, snowflake.x, snowflake.y);
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                ctx.closePath();
                ctx.fill();
            }
        }
    ]);
    return Snowflake;
}();
var $6c4c4f2fa51b5901$export$863fc42fa99cded6 = function Snowfall() {
    "use strict";
    var _this = this;
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0, $7uGB1._)(this, Snowfall);
    (0, $bHebQ._)(this, "requestAnimationFrame", void 0);
    /**
   * Resize the canvas and update snowflake positions after a window resize.
   */ (0, $bHebQ._)(this, "resizeCanvas", function() {
        var oldCanvasWidth, oldCanvasHeight;
        if (_this.snowflakes) {
            oldCanvasWidth = _this.canvas.width;
            oldCanvasHeight = _this.canvas.height;
        }
        _this.canvas.style.display = "none";
        // Set the width and height of the canvas equal to the width and height of the browser window
        if (window.devicePixelRatio > 1) {
            var scrollWidth = document.documentElement.scrollWidth;
            var scrollHeight;
            if ((0, $kx6Ww.params).snowfall.canvasHeightLimit !== 0) scrollHeight = Math.min(document.documentElement.scrollHeight, window.innerHeight * (0, $kx6Ww.params).snowfall.canvasHeightLimit);
            else scrollHeight = document.documentElement.scrollHeight;
            _this.canvas.width = scrollWidth * window.devicePixelRatio;
            _this.canvas.height = scrollHeight * window.devicePixelRatio;
            _this.canvas.style.width = scrollWidth + "px";
            _this.canvas.style.height = scrollHeight + "px";
            _this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);
        } else {
            _this.canvas.width = document.documentElement.scrollWidth;
            _this.canvas.height = document.documentElement.scrollHeight;
        }
        _this.canvas.style.display = "";
        if (_this.snowflakes) {
            var newCanvasWidth = _this.canvas.width;
            var newCanvasHeight = _this.canvas.height;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = _this.snowflakes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var snowflake = _step.value;
                    snowflake.updateAfterCanvasResize(oldCanvasWidth, oldCanvasHeight, newCanvasWidth, newCanvasHeight);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    });
    /**
   * Create snowflakes based on the specified count and parameters.
   * Generates a random radius (r) within the minimum and maximum radius.
   * Generates a relative value (rp) which is the position inside the specified
   * radius range: 0-100. This is is used to adjust the speed of the snowflake * according to its size.
   * Generates the speed (s) based on the size of the snowflake.
   */ (0, $bHebQ._)(this, "createSnowflakes", function() {
        for(var i = 0; i < _this.count; i++){
            var r = _this.minRadius + Math.random() * (_this.maxRadius - _this.minRadius);
            var rp = void 0;
            if (_this.minRadius !== _this.maxRadius) rp = (r - _this.minRadius) / ((_this.maxRadius - _this.minRadius) / 100);
            else rp = 100;
            var s = _this.minSpeed + (_this.maxSpeed - _this.minSpeed) / 100 * rp;
            var snowflake = new $6c4c4f2fa51b5901$export$3966b366d9a665fb(_this.canvas, r, s, _this.color, _this.text);
            _this.snowflakes.push(snowflake);
        }
    });
    /**
   * Animate the snowflakes by clearing the canvas and updating their positions.
   */ (0, $bHebQ._)(this, "animateSnowflakes", function() {
        _this.ctx.clearRect(0, 0, _this.canvas.width, _this.canvas.height);
        $6c4c4f2fa51b5901$export$3966b366d9a665fb.batchDraw(_this.ctx, _this.snowflakes, window.scrollX, window.scrollY, window.innerWidth, window.innerHeight);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // Update the positions of the snowflakes
            for(var _iterator = _this.snowflakes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var snowflake = _step.value;
                snowflake.update(_this.canvas);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // Request a new animation frame
        _this.requestAnimationFrame = requestAnimationFrame(_this.animateSnowflakes);
    });
    /**
   * Destroy the snowfall animation and remove the canvas element.
   */ (0, $bHebQ._)(this, "destroy", function() {
        window.removeEventListener("resize", _this.resizeHandler);
        cancelAnimationFrame(_this.requestAnimationFrame);
        document.getElementById("snowfall").remove();
        for(var name in _this)delete _this[name];
        // Empty the array of snowflakes
        _this.snowflakes = [];
    });
    var _options_count = options.count, count = _options_count === void 0 ? 100 : _options_count, _options_minRadius = options.minRadius, minRadius = _options_minRadius === void 0 ? 10 : _options_minRadius, _options_maxRadius = options.maxRadius, maxRadius = _options_maxRadius === void 0 ? 30 : _options_maxRadius, _options_minSpeed = options.minSpeed, minSpeed = _options_minSpeed === void 0 ? 3 : _options_minSpeed, _options_maxSpeed = options.maxSpeed, maxSpeed = _options_maxSpeed === void 0 ? 10 : _options_maxSpeed, _options_text = options.text, text = _options_text === void 0 ? "\u2744" : _options_text, _options_color = options.color, color = _options_color === void 0 ? "#99ccff" : _options_color, _options_zIndex = options.zIndex, zIndex = _options_zIndex === void 0 ? "1000" : _options_zIndex;
    count = Number(count);
    minRadius = Number(minRadius);
    if (minRadius <= 0) minRadius = 10;
    maxRadius = Number(maxRadius);
    if (maxRadius <= 0) maxRadius = 30;
    minSpeed = Number(minSpeed);
    maxSpeed = Number(maxSpeed);
    var snowfieldCanvas = document.createElement("canvas");
    snowfieldCanvas.id = "snowfall";
    snowfieldCanvas.style.zIndex = zIndex;
    snowfieldCanvas.style.position = "absolute";
    snowfieldCanvas.style.top = "0";
    snowfieldCanvas.style.left = "0";
    snowfieldCanvas.style.pointerEvents = "none";
    document.body.append(snowfieldCanvas);
    this.canvas = snowfieldCanvas;
    this.ctx = this.canvas.getContext("2d");
    this.resizeCanvas();
    window.addEventListener("resize", this.resizeHandler);
    this.resizeHandler = function() {
        requestAnimationFrame(_this.resizeCanvas.bind(_this));
    };
    this.snowflakes = [];
    this.count = count;
    this.minRadius = minRadius;
    this.maxRadius = maxRadius;
    this.minSpeed = minSpeed;
    this.maxSpeed = maxSpeed;
    this.color = color;
    this.text = text;
    this.createSnowflakes();
    this.animateSnowflakes();
};

});
parcelRegister("7uGB1", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $574c607528d33002$export$71511d61b312f219; });
function $574c607528d33002$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("kmCzq", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ed33c7f957347978$export$71511d61b312f219; });
function $ed33c7f957347978$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $ed33c7f957347978$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $ed33c7f957347978$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $ed33c7f957347978$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("bHebQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $883eb7b8928b487c$export$71511d61b312f219; });
function $883eb7b8928b487c$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("b2X0T", function(module, exports) {

$parcel$export(module.exports, "canRunAnimation", function () { return $80ada86d3dc64701$export$babdb309e5f76aee; });

var $hyRWj = parcelRequire("hyRWj");

var $5EFa1 = parcelRequire("5EFa1");

var $idtF5 = parcelRequire("idtF5");

var $g1GJK = parcelRequire("g1GJK");
function $80ada86d3dc64701$export$babdb309e5f76aee(configParams) {
    var hardwareCheck;
    var insideDateRange;
    var accessibilityCheck = true;
    if (configParams.checkHardware) hardwareCheck = (0, $5EFa1.checkHardware)();
    else hardwareCheck = true;
    if (configParams.checkDateRange) insideDateRange = (0, $hyRWj.checkDateRange)(configParams.dateRange);
    else insideDateRange = true;
    if (configParams.checkReducedMotionPreference) accessibilityCheck = (0, $g1GJK.checkReducedMotionConfig)(configParams);
    (0, $idtF5.logInfo)("Result of canRunAnimationCheck: hardwareCheck: ".concat(hardwareCheck, "; insideDateRange: ").concat(insideDateRange, "; accessibilityCheck: ").concat(accessibilityCheck));
    return hardwareCheck && insideDateRange && accessibilityCheck;
}

});
parcelRegister("hyRWj", function(module, exports) {

$parcel$export(module.exports, "checkDateRange", function () { return $034ca2e6db0f3cc4$export$6462223ab70e10af; });

var $idtF5 = parcelRequire("idtF5");
function $034ca2e6db0f3cc4$export$6462223ab70e10af() {
    var dateRange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var result = false;
    var validDateRange = true;
    if (Object.keys(dateRange).length !== 0) {
        validDateRange = $034ca2e6db0f3cc4$export$c03bb0116ee09d4b(dateRange.startMonth, dateRange.startDay) && $034ca2e6db0f3cc4$export$c03bb0116ee09d4b(dateRange.endMonth, dateRange.endDay);
        if (dateRange.startMonth === dateRange.endMonth && dateRange.startDay >= dateRange.endDay) validDateRange = false;
    }
    validDateRange ? result = $034ca2e6db0f3cc4$var$checkCurrentDate(dateRange) : (0, $idtF5.logError)("Invalid date range values provided in the config file. Check documentation for more information.");
    (0, $idtF5.logInfo)("Check Date Range Result: ".concat(result));
    return result;
}
/**
 * Validates the currentDate and passes the currentDate and dateRange values to the final verification check.
 *
 * @param {Object} dateRange - Object containing startMonth, startDay, endMonth, and endDay.
 * @returns {boolean} - True if the current date is within the range, false otherwise.
 */ function $034ca2e6db0f3cc4$var$checkCurrentDate(dateRange) {
    var currentDate = new Date();
    var currentMonth = currentDate.getMonth() + 1;
    var currentDay = currentDate.getDate();
    // Define the start and end dates for the condition, fallback to default
    var startMonth = dateRange.startMonth || 12; // December
    var startDay = dateRange.startDay || 15;
    var endMonth = dateRange.endMonth || 2; // February
    var endDay = dateRange.endDay || 15;
    return $034ca2e6db0f3cc4$var$isInDateRange(currentMonth, currentDay, startMonth, endMonth, startDay, endDay);
}
/**
 * Checks if the current date is within the specified date range.
 *
 * @param {number} currentMonth - Current month.
 * @param {number} currentDay - Current day.
 * @param {number} startMonth - Start month of the date range.
 * @param {number} endMonth - End month of the date range.
 * @param {number} startDay - Start day of the date range.
 * @param {number} endDay - End day of the date range.
 * @returns {boolean} - True if the current date is within the range, false otherwise.
 */ function $034ca2e6db0f3cc4$var$isInDateRange(currentMonth, currentDay, startMonth, endMonth, startDay, endDay) {
    if (startMonth < endMonth) return currentMonth === startMonth && currentDay >= startDay || currentMonth > startMonth && currentMonth < endMonth || currentMonth === endMonth && currentDay <= endDay;
    else if (startMonth === endMonth) return currentDay >= startDay && currentDay <= endDay;
    else return currentMonth === startMonth && currentDay >= startDay || currentMonth > startMonth && currentMonth <= 12 || currentMonth >= 1 && currentMonth < endMonth || currentMonth === endMonth && currentDay <= endDay;
}
function $034ca2e6db0f3cc4$export$c03bb0116ee09d4b(month, day) {
    if (typeof month !== "number" || typeof day !== "number") return false;
    if (month < 1 || month > 12) return false;
    // Check if the day is in the valid range based on the month
    if (day < 1 || day > $034ca2e6db0f3cc4$var$getDaysInMonth(month)) return false;
    return true;
}
/**
 * Gets the number of days in a given month.
 *
 * @param {number} month - Month for which to get the number of days.
 * @returns {number} - Number of days in the specified month.
 */ function $034ca2e6db0f3cc4$var$getDaysInMonth(month) {
    var daysInMonth = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    return daysInMonth[month - 1];
}

});
parcelRegister("idtF5", function(module, exports) {

$parcel$export(module.exports, "logError", function () { return $d4307317c0d0a4a9$export$58da9968c3170cb1; });
$parcel$export(module.exports, "logWarn", function () { return $d4307317c0d0a4a9$export$cc36178e946876e8; });
$parcel$export(module.exports, "logInfo", function () { return $d4307317c0d0a4a9$export$89c0607256d35f0a; });

var $kx6Ww = parcelRequire("kx6Ww");
function $d4307317c0d0a4a9$export$58da9968c3170cb1(message) {
    console.error("[ERROR] ".concat(message));
}
function $d4307317c0d0a4a9$export$cc36178e946876e8(message) {
    if ((0, $kx6Ww.params).logLevel === "info") console.warn("[WARN] ".concat(message));
}
function $d4307317c0d0a4a9$export$89c0607256d35f0a(message) {
    if ((0, $kx6Ww.params).logLevel === "info") console.log("[INFO] ".concat(message));
}

});


parcelRegister("5EFa1", function(module, exports) {

$parcel$export(module.exports, "checkHardware", function () { return $41e09dd03e1c7a25$export$fee43c3493ccc8e0; });

var $idtF5 = parcelRequire("idtF5");
function $41e09dd03e1c7a25$export$fee43c3493ccc8e0() {
    var cpuCores = navigator.hardwareConcurrency;
    var deviceMemory = navigator.deviceMemory;
    (0, $idtF5.logInfo)("Hardware Memory: ".concat(deviceMemory, " GB"));
    (0, $idtF5.logInfo)("Number of CPU cores: ".concat(cpuCores));
    if (deviceMemory >= 4 || cpuCores >= 4) return true;
    else return false;
}

});

parcelRegister("g1GJK", function(module, exports) {

$parcel$export(module.exports, "checkReducedMotionConfig", function () { return $baade3f909e618a9$export$1cf545b25ac5269e; });
$parcel$export(module.exports, "validateReduceMultiplier", function () { return $baade3f909e618a9$export$c2cce2c495aa1aea; });

var $idtF5 = parcelRequire("idtF5");
function $baade3f909e618a9$export$1cf545b25ac5269e(configParams) {
    var prefersReducedMotion = window.matchMedia("(prefers-reduced-motion)").matches;
    if (prefersReducedMotion && configParams.setReducedMotion === "disable") return false;
    else return true; // case: setReducedMotion = "reduce" or no-preference set in browser configuration
}
function $baade3f909e618a9$export$c2cce2c495aa1aea(configParams) {
    var inRange = configParams.reduceMultiplier > 0.1 && configParams.reduceMultiplier < 0.9;
    if (inRange) return configParams.reduceMultiplier;
    else {
        (0, $idtF5.logWarn)("Input ".concat(configParams.reduceMultiplier, " is an invalid motion reduce multiplier value. Use a number value between 0.1 and 0.9! Fallback value 0.5 will be used."));
        return 0.5;
    }
}

});


parcelRegister("108uK", function(module, exports) {

$parcel$export(module.exports, "switchesAppendToDOM", function () { return $0bac6175610bf0da$export$48d655b99b5ade63; });
$parcel$export(module.exports, "switchesToggleOn", function () { return $0bac6175610bf0da$export$e180b1645289b623; });
$parcel$export(module.exports, "switchesSetupEventHandlers", function () { return $0bac6175610bf0da$export$8b810da3348543c0; });

var $kjcrH = parcelRequire("kjcrH");

var $kx6Ww = parcelRequire("kx6Ww");

var $idtF5 = parcelRequire("idtF5");
function $0bac6175610bf0da$export$48d655b99b5ade63(params) {
    var switchContainers = document.querySelectorAll(".snow-animation-switch");
    if (switchContainers.length > 0) {
        switchContainers.forEach(function(container, i) {
            var switchElements = $0bac6175610bf0da$var$buildSwitch(i, params);
            switchElements.forEach(function(elem) {
                return container.appendChild(elem);
            });
            container.classList.add("snow-animation-switch--show");
        });
        if (params.switches.injectCSS) $0bac6175610bf0da$var$injectCSS(params);
        (0, $idtF5.logInfo)("".concat(switchContainers.length, " switch container elements found and ").concat(switchContainers.length, " switch toggles appended to the DOM."));
    } else {
        (0, $idtF5.logWarn)("No switch container elements found in the DOM. Make sure you have at least one <div class='snow-animation-switch'></div>.");
        return null;
    }
}
/**
 * Builds snowfall switch elements.
 *
 * @param {number} i - Index for creating unique IDs.
 * @param {Object} params - Snowfall parameters.
 * @returns {HTMLElement[]} - Array of switch elements.
 */ function $0bac6175610bf0da$var$buildSwitch(i, params) {
    var inputElem = document.createElement("input");
    var label = document.createElement("label");
    var textElem = document.createElement("span");
    inputElem.classList.add("snow-animation-switch__input");
    inputElem.type = "checkbox";
    inputElem.id = "snow-animation-switch__input".concat(i);
    label.classList.add("snow-animation-switch__label");
    label.htmlFor = "snow-animation-switch__input".concat(i);
    label.tabIndex = 0;
    textElem.classList.add("snow-animation-switch__text");
    textElem.textContent = params.switches.txt;
    if (params.switches.txtElemAttributes.length > 0) $0bac6175610bf0da$var$setElemAttributes(textElem, params.switches.txtElemAttributes);
    return [
        inputElem,
        label,
        textElem
    ];
}
/**
 * Sets attributes on an HTML element.
 *
 * @param {HTMLElement} elem - The HTML element to set attributes on.
 * @param {Object[]} attributes - Array of attribute objects.
 */ function $0bac6175610bf0da$var$setElemAttributes(elem, attributes) {
    attributes.forEach(function(attr) {
        if (attr.type === "data-attribute") elem.dataset[attr.name] = attr.value;
        else elem[attr.name] = attr.value;
    });
}

/**
 * Injects CSS stylesheet into the document.
 *
 * @param {Object} params - Snowfall parameters.
 */ function $0bac6175610bf0da$var$injectCSS(params) {
    var linkElement = document.createElement("link");
    var root = document.documentElement;
    var rootStyles = params.switches.styles;
    for(var key in rootStyles){
        root.style.setProperty("--snow-animation-switch-".concat(key), rootStyles[key]);
        if (key === "txtPosition" && rootStyles[key] === "1") root.style.setProperty("--snow-animation-switch-txtMargin", "0 0.75em 0 0");
    }
    linkElement.rel = "stylesheet";
    linkElement.type = "text/css";
    linkElement.href = new URL((parcelRequire("6m9DV")));
    document.head.appendChild(linkElement);
}
function $0bac6175610bf0da$export$e180b1645289b623() {
    var inputElems = document.querySelectorAll(".snow-animation-switch__input");
    inputElems.forEach(function(elem) {
        elem.checked = true;
        elem.ariaChecked = true;
        (0, $idtF5.logInfo)("Switch toggled ON");
    });
}
function $0bac6175610bf0da$export$8b810da3348543c0(params) {
    var labelElems = document.querySelectorAll(".snow-animation-switch__label");
    labelElems.forEach(function(label) {
        label.addEventListener("click", function(event) {
            return $0bac6175610bf0da$var$handleEvents(event, undefined, params);
        });
        label.addEventListener("keydown", function(event) {
            event.preventDefault();
            if (event.key === "Enter" || event.keyCode === 13) $0bac6175610bf0da$var$handleEvents(event, label, params);
        });
    });
}
/**
 * Handles click and enter key events for snowfall switches.
 *
 * @param {Event} event - The event object.
 * @param {HTMLElement} label - The label element associated with the switch.
 * @param {Object} params - Snowfall parameters.
 */ function $0bac6175610bf0da$var$handleEvents(event, label, params) {
    if ((0, $kx6Ww.snowfallState).isAnimationRunning) {
        $0bac6175610bf0da$var$stopAnimation(event, params);
        /* the enter key event does not check the checkbox automatically */ if (label) {
            label.previousElementSibling.checked = false;
            label.previousElementSibling.ariaChecked = false;
        }
    } else {
        $0bac6175610bf0da$var$startAnimation(event, params);
        if (label) {
            label.previousElementSibling.checked = true;
            label.previousElementSibling.ariaChecked = true;
        }
    }
}
/**
 * Stops the snowfall animation and updates switch states.
 *
 * @param {Event} event - The event object.
 * @param {Object} params - Snowfall parameters.
 */ function $0bac6175610bf0da$var$stopAnimation(event, params) {
    (0, $kx6Ww.snowfallState).snowfallInstance.destroy();
    (0, $kx6Ww.snowfallState).isAnimationRunning = false;
    (0, $idtF5.logInfo)("Animation stopped.");
    if (params.switches.storeUserSettings) (0, $kjcrH.setUserSettings)({
        runSnowfallAnimation: false
    });
    $0bac6175610bf0da$var$syncStateOtherSwitches(event);
}
/**
 * Starts the snowfall animation and updates switch states.
 *
 * @param {Event} event - The event object.
 * @param {Object} params - Snowfall parameters.
 */ function $0bac6175610bf0da$var$startAnimation(event, params) {
    (0, $kx6Ww.snowfallState).snowfallInstance = (0, $kx6Ww.initSnowfall)(params.snowfall);
    (0, $kx6Ww.snowfallState).isAnimationRunning = true;
    (0, $idtF5.logInfo)("Animation started.");
    if (params.switches.storeUserSettings) (0, $kjcrH.setUserSettings)({
        runSnowfallAnimation: true
    });
    $0bac6175610bf0da$var$syncStateOtherSwitches(event);
}
/**
 * Syncs the state of other switches based on the current switch state.
 *
 * @param {Event} event - The event object.
 */ function $0bac6175610bf0da$var$syncStateOtherSwitches(event) {
    document.querySelectorAll(".snow-animation-switch__input").forEach(function(elem) {
        if (elem.id !== event.target.previousElementSibling.id) {
            elem.checked = (0, $kx6Ww.snowfallState).isAnimationRunning;
            elem.ariaChecked = (0, $kx6Ww.snowfallState).isAnimationRunning;
            (0, $idtF5.logInfo)("Switch state synced.");
        }
    });
}

});
parcelRegister("kjcrH", function(module, exports) {

$parcel$export(module.exports, "checkUserSettings", function () { return $ec8f3c7cacf9234a$export$8a2e0f615212a6a7; });
$parcel$export(module.exports, "setUserSettings", function () { return $ec8f3c7cacf9234a$export$a09ac3e43ac36a79; });

var $1lZ9K = parcelRequire("1lZ9K");

var $idtF5 = parcelRequire("idtF5");
function $ec8f3c7cacf9234a$export$8a2e0f615212a6a7() {
    if ($ec8f3c7cacf9234a$export$bdf060f8502bcfbd().runSnowfallAnimation) return true;
    else if ($ec8f3c7cacf9234a$export$bdf060f8502bcfbd().runSnowfallAnimation === false) return false;
    else return undefined;
}
function $ec8f3c7cacf9234a$export$bdf060f8502bcfbd() {
    try {
        var settingsJSON = localStorage.getItem("userSettings");
        var settings = JSON.parse(settingsJSON) || {};
        return settings;
    } catch (error) {
        (0, $idtF5.logError)("Error retrieving user settings: ".concat(error));
        return null;
    }
}
function $ec8f3c7cacf9234a$export$a09ac3e43ac36a79(newSettings) {
    try {
        var existingSettingsJSON = localStorage.getItem("userSettings");
        var existingSettings = JSON.parse(existingSettingsJSON) || {};
        var mergedSettings = (0, $1lZ9K._)({}, existingSettings, newSettings);
        var mergedSettingsJSON = JSON.stringify(mergedSettings);
        localStorage.setItem("userSettings", mergedSettingsJSON);
        (0, $idtF5.logInfo)("User settings saved successfully.");
    } catch (error) {
        (0, $idtF5.logError)("Error saving user settings: ".concat(error));
    }
}

});
parcelRegister("1lZ9K", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0fc730f9c57442c1$export$71511d61b312f219; });

var $bHebQ = parcelRequire("bHebQ");
function $0fc730f9c57442c1$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $bHebQ._)(target, key, source[key]);
        });
    }
    return target;
}

});


parcelRegister("6m9DV", function(module, exports) {
module.exports = $parcel$resolve("dLFrV");

});


parcelRegister("29t6j", function(module, exports) {

$parcel$export(module.exports, "setParams", function () { return $1912fedcb913e8e9$export$dc1827290674c112; });

var $1lZ9K = parcelRequire("1lZ9K");

var $jW7UK = parcelRequire("jW7UK");

var $6RMvr = parcelRequire("6RMvr");

var $idtF5 = parcelRequire("idtF5");

var $g1GJK = parcelRequire("g1GJK");
function $1912fedcb913e8e9$export$dc1827290674c112(configParams) {
    var defaultParams = (0, $6RMvr.getDefaultParams)();
    var params = $1912fedcb913e8e9$export$28ea1ca525ed812a(defaultParams, configParams);
    (0, $idtF5.logInfo)("Done setting snowfall-js-plugin parameters.");
    return params;
}
function $1912fedcb913e8e9$export$28ea1ca525ed812a(defaultConfig, configParams) {
    var mergedConfig = (0, $1lZ9K._)({}, defaultConfig);
    for(var key in configParams)if (configParams.hasOwnProperty(key)) {
        // Validate if the key exists in the defaultConfig
        if (!(key in defaultConfig)) {
            (0, $idtF5.logWarn)("Warning: '".concat(key, "' does not exist in the default configuration and will be ignored."));
            continue;
        }
        var configValue = configParams[key];
        var defaultValue = defaultConfig[key];
        // Validate if the types match
        if ((typeof configValue === "undefined" ? "undefined" : (0, $jW7UK._)(configValue)) !== (typeof defaultValue === "undefined" ? "undefined" : (0, $jW7UK._)(defaultValue))) {
            (0, $idtF5.logWarn)("Warning: Type mismatch for '".concat(key, "'. Using default value."));
            continue;
        }
        // Recursive merge for nested objects
        if (configValue instanceof Object && !Array.isArray(configValue) && defaultValue instanceof Object && !Array.isArray(defaultValue)) mergedConfig[key] = $1912fedcb913e8e9$export$28ea1ca525ed812a(defaultValue, configValue);
        else // Overwrite values from configParams into mergedConfig
        mergedConfig[key] = configValue;
    }
    // Additional logic for handling reduced motion preference
    if (configParams !== null && configParams.checkReducedMotionPreference === true && configParams.hasOwnProperty("setReducedMotion") && configParams.setReducedMotion === "reduce") {
        var reduceMultiplier = (0, $g1GJK.validateReduceMultiplier)(mergedConfig, configParams);
        mergedConfig.snowfall.count = Math.round(mergedConfig.snowfall.count * reduceMultiplier);
    }
    return mergedConfig;
}

});
parcelRegister("6RMvr", function(module, exports) {

$parcel$export(module.exports, "getDefaultParams", function () { return $4ffd519940a83988$export$23e4d4234edf4b25; });
/**
 * Retrieves the default parameters for the application.
 *
 * @returns {object} The default parameters object.
 */ function $4ffd519940a83988$export$23e4d4234edf4b25() {
    return $4ffd519940a83988$var$defaultParams;
}
var $4ffd519940a83988$var$defaultParams = {
    logLevel: "default",
    checkHardware: true,
    checkDateRange: true,
    dateRange: {
        startMonth: 12,
        endMonth: 2,
        startDay: 15,
        endDay: 15
    },
    autostartOnMobile: true,
    autostartOnDesktop: true,
    screenWidthThreshold: 768,
    checkReducedMotionPreference: true,
    setReducedMotion: "disable",
    reduceMultiplier: 0.5,
    // experimental: reduces snowfall count by 50%, use value between 0.1-0.9
    snowfall: {
        count: 33,
        minRadius: 10,
        maxRadius: 30,
        minSpeed: 3,
        maxSpeed: 6,
        text: "\u2744",
        color: "#99ccff",
        zIndex: "1000",
        canvasHeightLimit: 0
    },
    switches: {
        show: true,
        storeUserSettings: true,
        txt: "Snow",
        txtElemAttributes: [],
        injectCSS: true,
        styles: {
            /* background color of the switch when turned off */ bgClrOff: "rgba(189, 195, 199, 1)",
            /* background color of the switch when turned on */ bgClrOn: "rgba(149, 165, 166, 1)",
            /* color of the moving toggle inside switch */ toggleClr: "#ffffff",
            /* color and position of the text next to the switch */ txtClr: "rgba(33, 37, 41, 1)",
            txtPosition: "2"
        }
    }
};

});


parcelRegister("liPuM", function(module, exports) {

$parcel$export(module.exports, "getAutoStart", function () { return $f823395a5d0ddcc7$export$e61d1c3f5b3887; });

var $kjcrH = parcelRequire("kjcrH");

var $idtF5 = parcelRequire("idtF5");
function $f823395a5d0ddcc7$export$e61d1c3f5b3887(configParams) {
    var autostartConfig = $f823395a5d0ddcc7$var$getAutostartConfig(configParams);
    var userPreference = (0, $kjcrH.checkUserSettings)(); // true, false or undefined
    (0, $idtF5.logInfo)("Autostart Config Value: ".concat(autostartConfig));
    (0, $idtF5.logInfo)("User Preference: ".concat(userPreference));
    // user preferences takes precedence over autoStartConfig
    if (userPreference !== undefined) return userPreference;
    else return autostartConfig;
}
/**
 * Determines the auto-start configuration based on the provided parameters.
 *
 * @param {Object} configParams - Configuration parameters.
 * @returns {boolean} - True if the animation should auto-start, false otherwise.
 */ function $f823395a5d0ddcc7$var$getAutostartConfig(configParams) {
    if (configParams.autostartOnMobile && configParams.autostartOnDesktop) return true;
    else {
        var screenWidthThreshold = configParams.screenWidthThreshold || 768;
        if (window.innerWidth >= screenWidthThreshold && configParams.autostartOnDesktop) return true;
        else if (window.innerHeight <= screenWidthThreshold && configParams.autostartOnMobile) return true;
        else return false;
    }
}

});


parcelRegister("4Y76G", function(module, exports) {

$parcel$export(module.exports, "snowfallJsPluginParams", function () { return $39e247434807bc3e$export$8546e27d37a44fe5; });
var $39e247434807bc3e$export$8546e27d37a44fe5 = {
    snowfall: {
        count: 54,
        canvasHeightLimit: 4
    },
    switches: {
        txt: "Sneeuw",
        txtElemAttributes: [
            {
                type: "data-attribute",
                name: "txt_id",
                value: "[702]"
            }
        ],
        styles: {
            bgClrOff: "#F9E3AE40",
            bgClrOn: "#003f8c",
            toggleClr: "#2496ed",
            txtClr: "#2496ed"
        }
    }
};

});


var $9698e70cd2122e28$exports = {};
$parcel$extendImportMap({
    "dLFrV": "snowAnimationSwitchStyles.1d265b48.css"
});


parcelRequire("8B93W");
})();
//# sourceMappingURL=vendor.505ded4b.js.map
